import { StatusBar, StyleSheet, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIphoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

export const STATUSBAR_THEME = Object.freeze({
  LIGHT: 'light-content',
  DARK: 'dark-content',
});
const isWeb = Platform.OS === 'web'

export default StyleSheet.create({
  iosStatusBarView: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 20,
    height: isIphoneWithNotch ? 48 : 24,
    width: '100%',
  },
  androidContainerStyle: {
    paddingTop: StatusBar.currentHeight,
  },
  flatListStyle: isEIOCollapsed => ({
    marginBottom: isEIOCollapsed ? -100 : 15,
  }),
  overlayImage: { width: 124.8, height: 124.8 },
  footer: {
    height: isWeb ? 0 : 800,
    backgroundColor: Colors.whiteSmoke,
    marginBottom: -1000,
  },
  errorContainer: {
    width: '100%',
  },
});
